import { AutogenModelProspectType, AutogenRowProspectType } from "./autogen/AutogenModelProspectType";

export class ModelProspectType extends AutogenModelProspectType<RowProspectType> {
	constructor() {
		super(RowProspectType);
	}
}

export class RowProspectType extends AutogenRowProspectType {
}